import { Box } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"

import { Section, Text } from "@jewlr/storybook/info"
import { IS_CA } from "helpers/application"

const SMSTermsConditions = () => {
  return (
    <Box mb={7}>
      <Section>
        <Box contain>
          <Text>
            By signing up to receive text messages from Jewlr, you consent to
            receive recurring automated marketing (including shopping cart
            reminders) text messages (e.g., SMS and MMS) from Jewlr. These
            messages may be sent using an automatic telephone dialing system to
            the mobile number you provided when signing up or any other number
            you designate.
          </Text>
          <Text>
            Your consent to receive automated marketing messages is not a
            condition of any purchase. Message and data rates may apply.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Message Frequency & Service Changes</Text>
          <Text>
            Message frequency will vary. Jewlr reserves the right to alter the
            frequency of messages sent at any time, either increasing or
            decreasing the number of messages. We may also change the short code
            or phone number from which messages are sent, and we will notify you
            in the event of such changes.
          </Text>
          <Text>
            <b>International Availability:</b> While Jewlr operates globally,
            messaging services may not be available in all countries. Delivery
            of messages depends on mobile carriers, service providers, and other
            technical factors beyond our control.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Liability Disclaimer</Text>
          <Text>
            Jewlr, its service providers, and mobile carriers are not liable for
            delayed, misdirected, or undelivered messages. We are not
            responsible for technical failures, network issues, third-party
            errors, or any damages arising from the use of this messaging
            service.
          </Text>
          <Text>
            To the fullest extent permitted by law, Jewlr disclaims liability
            for any indirect, incidental, or consequential damages related to
            the messaging service.
          </Text>
          <Text>
            You also agree to our{" "}
            <Link to="/info/terms-conditions">Jewlr Terms of Use</Link> and{" "}
            <Link to="/info/privacy-policy">Jewlr Privacy Policy</Link>.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Opt-Out & Cancellation</Text>
          <Text>
            You may opt out of receiving text messages at any time by texting
            one of the following keywords to our shortcode:
            <br />
            <b>
              STOP, END, CANCEL, UNSUBSCRIBE
              {IS_CA() ? ", QUIT, or ARRET" : " or QUIT"}.
            </b>
          </Text>
          <Text>
            After sending an opt-out request, you will receive{" "}
            <b>one final confirmation message</b> confirming your request. You
            acknowledge that our system may not process unsubscribe requests
            that do not include the exact keywords listed above.
          </Text>
          <Text>
            Opting out of one Jewlr text messaging program does not{" "}
            automatically unsubscribe you from other Jewlr programs you may have
            signed up for. You may also continue to receive other electronic
            communications from Jewlr, such as marketing emails or transactional
            notifications.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Mobile Phone Number Changes</Text>
          <Text>
            If you change or deactivate your mobile number, you must notify
            Jewlr to ensure that messages are not sent to the incorrect
            recipient. Please update your contact details by visiting{" "}
            <Link to="/helpdesk">Jewlr Helpdesk</Link>.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Privacy & Data Usage</Text>
          <Text>
            By signing up for text messages, you acknowledge that Jewlr may
            collect and store your phone number, message history, and other
            related data in accordance with our{" "}
            <Link to="/info/sms-privacy-policy">Privacy Policy</Link>.<br />
            We do not sell or share your phone number with third parties for
            marketing purposes. Data is retained for compliance and operational
            purposes only, as permitted by applicable laws such as GDPR, CCPA,
            and CASL.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Help & Customer Support</Text>
          <Text>
            For assistance, text <b>HELP</b>
            {IS_CA() && (
              <>
                {" "}
                or <b>AIDE</b>
              </>
            )}{" "}
            to our shortcode.
            <br />
            If you are experiencing issues, please visit{" "}
            <Link to="/helpdesk">Jewlr Helpdesk</Link> or email{" "}
            <a
              href={`mailto:${sl.config.customer_service_email}`}
              rel="nofollow"
            >
              {sl.config.customer_service_email}
            </a>
            .
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Governing Law & Dispute Resolution</Text>
          <Text>
            These Messaging Terms & Conditions are governed by the laws of{" "}
            Ontario, Canada. Any disputes arising from or related to this
            messaging program shall be resolved through binding arbitration in
            Ontario, except where prohibited by law.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Changes to Messaging Terms</Text>
          <Text>
            Jewlr reserves the right to modify or terminate this messaging
            program at any time. Changes to these terms will take effect
            immediately upon posting, and continued use of the service
            constitutes acceptance of the revised terms.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <Text subtitle>Contact Information</Text>
          <Text>
            This messaging service is provided by:
            <br />
            <b>Jewlr</b>
            <br />
            5050 Dufferin St, Suite 112, Toronto, Ontario M3H5T5
            <br />
            Email:{" "}
            <a href="mailto:help@jewlr.com" rel="nofollow">
              help@jewlr.com
            </a>
          </Text>
        </Box>
      </Section>
    </Box>
  )
}

export default SMSTermsConditions
